import auth from '../auth';
import ApigClientFactory from '../apigClient';

export const MetricsService = {

    async getMetrics(criteria) {
        return this.get(criteria, 'image');
    },

    async getStatistics(criteria) {
        return this.get(criteria, 'statistics');
    },

    async get(criteria, metricType) {
        let config = {
            invokeUrl: process.env.RTPS_API_URL,
            region: process.env.AWS_REGION,
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };

        await auth.getCredentialsForRole(process.env.RTPS_ROLE_SEARCH)
            .then((credentials) => {
                config.accessKey = credentials.Credentials.AccessKeyId;
                config.secretKey = credentials.Credentials.SecretKey;
                config.sessionToken = credentials.Credentials.SessionToken;
            });

        let client = ApigClientFactory.newClient(config);

        return client.invokeApi({}, `/metrics/${metricType}`, 'POST', {}, criteria);
    }
};



// WEBPACK FOOTER //
// ./src/services/rtps/metrics.service.js